import React, { createElement, useState } from 'react';
import './index.scss';
import ErrorBoundary from '../../common/errorBoundary';
import ErrorComponent from '../../common/errorComponent';
const Card = (props) => {
    const { valueColor, titleColor, width, title, value, size, fontSize, type, siderColor, singleColor, } = props;
    const sider = type === 'sider'
        ? {
            borderLeft: `2px solid ${siderColor}`,
        }
        : {};
    const bgc = type === 'full'
        ? {
            backgroundColor: singleColor,
            borderRadius: '5px',
        }
        : {};
    const height = {
        height: size === 'big' ? '80px' : '66px',
    };
    const style = {
        ...sider,
        ...bgc,
        ...height,
        ...height,
        width: width + '%',
    };
    return (createElement("div", { style: style, className: "card-item base_bg" },
        createElement("p", { className: "card-item-title", style: { color: titleColor } }, title),
        createElement("p", { className: `card-item-value card-item-value-${fontSize}`, style: { color: valueColor } }, value)));
};
const IndicatorCard = (props, ref) => {
    const { position, ...other } = props;
    const [error, setError] = useState(false);
    return (createElement(ErrorBoundary, null, error ? (createElement(ErrorComponent, { ref: ref })) : (createElement("div", { ref: ref, className: "card-box", style: { justifyContent: position } },
        createElement(Card, Object.assign({}, other))))));
};
export default React.forwardRef(IndicatorCard);
